module.exports = __webpack_public_path__ + "static/4-7ad6a5932f4c911b0620317d669be9d3.jpg";